const stylesGlobal = {
  navbar: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#0D0D0D",
    padding: "calc(1rem + 0.5vw) calc(2rem + 2vw)", // 🔹 Padding dinâmico
    boxSizing: "border-box",
    zIndex: 9999,
  },

  logoContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  logoImage: {
    width: "clamp(8rem, 10vw, 10rem)", // 🔹 Mantém responsivo
    height: "auto",
  },

  button: {
    backgroundColor: "#F68500",
    border: "none",
    color: "#FFF",
    borderRadius: "30px",
    padding: "calc(0.5rem + 0.4vw) calc(1rem + 0.5vw)", // 🔹 Reduz dinamicamente
    cursor: "pointer",
    fontSize: "clamp(0.8rem, 1.2vw, 1rem)", // 🔹 Fonte responsiva
    transition: "all 0.3s ease",
  },

  buttonHover: {
    transform: "scale(1.03)",
  },

  linkActive: {
    color: "#F68500",
  },
};

export default stylesGlobal;
